import { FeatureFlag } from '../FeatureFlag';

export const locatesV2UserOnlyFiltering = new FeatureFlag({
    key: 'locates-v2-user-only-filtering',
    defaultValue: false,
});
